module.exports = __webpack_public_path__ + "static/media/hiring-process-mobile.85125f36.jpg";